var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5652_6357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.38077 0.573266C8.83279 0.203195 9.40673 0 10 0C10.5933 0 11.1672 0.203195 11.6192 0.573266L19.1192 6.71251C19.3953 6.93852 19.617 7.21962 19.7691 7.53635C19.9212 7.85307 20 8.19785 20 8.5468V18.1479C20 18.6391 19.7974 19.1102 19.4367 19.4575C19.0761 19.8049 18.587 20 18.0769 20H15C14.49 20 14.0008 19.8049 13.6402 19.4575C13.2795 19.1102 13.0769 18.6391 13.0769 18.1479V13.3325C13.0769 12.9407 12.9158 12.5649 12.6288 12.2872C12.3417 12.0095 11.9522 11.8527 11.5454 11.8509H8.45385C8.04716 11.8528 7.65782 12.0098 7.37096 12.2875C7.0841 12.5651 6.92307 12.9409 6.92308 13.3325V18.1479C6.92308 18.3911 6.87334 18.632 6.77669 18.8567C6.68005 19.0814 6.53839 19.2856 6.35982 19.4575C6.18125 19.6295 5.96925 19.7659 5.73593 19.859C5.50261 19.9521 5.25254 20 5 20H1.92308C1.41305 20 0.923903 19.8049 0.563256 19.4575C0.202609 19.1102 0 18.6391 0 18.1479V8.5468C2.02392e-05 8.19785 0.0787988 7.85307 0.23088 7.53635C0.382961 7.21962 0.60471 6.93852 0.880769 6.71251L8.38077 0.573266Z",
    fill: "#3B1F8E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5652_6357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIconActive);
export default __webpack_public_path__ + "static/media/homeIconActive.16924d6c14b2f4315cc1b52bcce84c96.svg";
export { ForwardRef as ReactComponent };